import { render, staticRenderFns } from "./DecimalField.vue?vue&type=template&id=331974bd&"
import script from "./DecimalField.vue?vue&type=script&lang=ts&"
export * from "./DecimalField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports